module.exports = __webpack_public_path__ + "img/2x-11.d54d7c24.png";